module.exports = __webpack_public_path__ + "img/0445_05.5b66f8f1.jpg";